import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  available:    { label: "Available",    className: "bg-blue-100 text-blue-700 hover:bg-blue-100" },
  occupied:     { label: "Occupied",     className: "bg-green-100 text-green-700 hover:bg-green-100" },
  renovation:   { label: "Renovation",   className: "bg-orange-100 text-orange-700 hover:bg-orange-100" },
  for_sale:     { label: "For Sale",     className: "bg-purple-100 text-purple-700 hover:bg-purple-100" },
  archived:     { label: "Archived",     className: "bg-gray-100 text-gray-500 hover:bg-gray-100" },
  active:       { label: "Active",       className: "bg-green-100 text-green-700 hover:bg-green-100" },
  notice:       { label: "Notice",       className: "bg-orange-100 text-orange-700 hover:bg-orange-100" },
  expired:      { label: "Expired",      className: "bg-red-100 text-red-700 hover:bg-red-100" },
  ended:        { label: "Ended",        className: "bg-gray-100 text-gray-500 hover:bg-gray-100" },
  paid:         { label: "Paid",         className: "bg-green-100 text-green-700 hover:bg-green-100" },
  pending:      { label: "Pending",      className: "bg-blue-100 text-blue-700 hover:bg-blue-100" },
  partial:      { label: "Partial",      className: "bg-yellow-100 text-yellow-700 hover:bg-yellow-100" },
  late:         { label: "Late",         className: "bg-red-100 text-red-700 hover:bg-red-100" },
  unpaid:       { label: "Unpaid",       className: "bg-red-100 text-red-700 hover:bg-red-100" },
  cancelled:    { label: "Cancelled",    className: "bg-gray-100 text-gray-500 hover:bg-gray-100" },
  open:         { label: "Open",         className: "bg-red-100 text-red-700 hover:bg-red-100" },
  in_progress:  { label: "In Progress",  className: "bg-blue-100 text-blue-700 hover:bg-blue-100" },
  completed:    { label: "Completed",    className: "bg-green-100 text-green-700 hover:bg-green-100" },
  low:          { label: "Low",          className: "bg-gray-100 text-gray-600 hover:bg-gray-100" },
  medium:       { label: "Medium",       className: "bg-yellow-100 text-yellow-700 hover:bg-yellow-100" },
  high:         { label: "High",         className: "bg-orange-100 text-orange-700 hover:bg-orange-100" },
  emergency:    { label: "Emergency",    className: "bg-red-100 text-red-700 hover:bg-red-100" },
  trialing:     { label: "Trial",        className: "bg-blue-100 text-blue-700 hover:bg-blue-100" },
  new:          { label: "New",          className: "bg-blue-100 text-blue-700 hover:bg-blue-100" },
  contacted:    { label: "Contacted",    className: "bg-yellow-100 text-yellow-700 hover:bg-yellow-100" },
  converted:    { label: "Converted",    className: "bg-green-100 text-green-700 hover:bg-green-100" },
  rejected:     { label: "Rejected",     className: "bg-gray-100 text-gray-500 hover:bg-gray-100" },
}

interface StatusBadgeProps {
  status: string
  className?: string
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: "bg-gray-100 text-gray-600" }
  return (
    <Badge
      className={cn(
        "rounded-lg px-2.5 py-0.5 text-xs font-medium border-0",
        config.className,
        className
      )}
    >
      {config.label}
    </Badge>
  )
}
